(function () {
  'use strict';

  var initializedAttribute = 'data-native-swatches-initialized';

  function setAddButtonPrompt(productSection, text) {
    var addButton = productSection.querySelector('[data-add-to-cart]');
    var addButtonText = productSection.querySelector('[data-add-to-cart-text]');

    if (addButton) {
      addButton.disabled = true;
      addButton.classList.add('disabled');
    }
    if (addButtonText) addButtonText.textContent = text;
  }

  function syncUnselectedOptionAvailability(productSection, optionGroup) {
    var variantsJson = productSection.querySelector('[data-variant-json]');
    var optionIndex = optionGroup.getAttribute('data-index');
    var isColor = optionGroup.hasAttribute('data-native-color-option');
    var variants;

    if (!variantsJson || !optionIndex) return;

    try {
      variants = JSON.parse(variantsJson.textContent || '[]');
    } catch (error) {
      return;
    }

    optionGroup.querySelectorAll('[data-variant-input]').forEach(function (input) {
      var label = input.parentElement.querySelector('label');
      var available = variants.some(function (variant) {
        return variant.available && String(variant[optionIndex]) === String(input.value);
      });

      input.disabled = false;
      input.classList.toggle('disabled', !available);
      input.removeAttribute('aria-disabled');
      input.toggleAttribute('data-sold-out', !available);

      if (!label) return;

      label.classList.toggle('disabled', !available);
      label.removeAttribute('aria-disabled');
      label.toggleAttribute('data-sold-out', !available);
      label.setAttribute('aria-label', input.value + (available ? '' : ', sold out'));
      if (isColor || !available) {
        label.setAttribute('title', input.value + (available ? '' : ' - sold out'));
      } else {
        label.removeAttribute('title');
      }
    });
  }

  function syncRequiredSelections(productSection) {
    if (productSection.dataset.dwClearanceProduct === 'true') {
      var variantsJson = productSection.querySelector('[data-variant-json]');
      var variants = variantsJson && JSON.parse(variantsJson.textContent || '[]');
      if (variants && !variants.some(function(variant) { return variant.available; })) {
        setAddButtonPrompt(productSection, theme.strings.soldOut);
        return;
      }
    }
    var groups = Array.from(productSection.querySelectorAll('.variant-input-wrap'));
    var missingColorGroup = groups.find(function (group) {
      return group.hasAttribute('data-native-color-option') && !group.querySelector('[data-variant-input]:checked');
    });
    var missingGroup = missingColorGroup || groups.find(function (group) {
      return !group.querySelector('[data-variant-input]:checked');
    });

    if (!missingGroup) {
      productSection.classList.remove('native-swatch-awaiting-selection');
      return;
    }

    var optionName = (missingGroup.getAttribute('name') || 'option').toLowerCase();
    var prompt = optionName.indexOf('colo') !== -1 ? 'Select a colour' : 'Select a ' + optionName;

    productSection.classList.add('native-swatch-awaiting-selection');
    setAddButtonPrompt(productSection, prompt);
  }

  function sizeSortKey(value) {
    var normalized = String(value || '').trim().toUpperCase();
    if (/^\d+(?:\.\d+)?$/.test(normalized)) return { system: 'number', rank: Number(normalized) };

    var clothingSizes = {
      XXXS: 0, '3XS': 0, XXS: 1, '2XS': 1, XS: 2,
      S: 3, SMALL: 3, M: 4, MEDIUM: 4, L: 5, LARGE: 5,
      XL: 6, XXL: 7, '2XL': 7, XXXL: 8, '3XL': 8,
      XXXXL: 9, '4XL': 9, '5XL': 10, '6XL': 11
    };
    if (Object.prototype.hasOwnProperty.call(clothingSizes, normalized)) {
      return { system: 'clothing', rank: clothingSizes[normalized] };
    }
    return null;
  }

  function sortSizeOptions(productSection) {
    productSection.querySelectorAll('.variant-input-wrap').forEach(function (group) {
      var name = group.getAttribute('name') || group.getAttribute('data-handle') || '';
      if (!/size|sizing/i.test(name)) return;
      var select = group.querySelector('select[data-variant-input]');
      var parent = select || group;
      var choices = Array.from(parent.children).filter(function (child) {
        return select ? child.tagName === 'OPTION' : child.classList.contains('variant-input');
      });
      if (choices.length < 2) return;
      var entries = choices.map(function (choice, index) {
        var value = select ? choice.value : choice.getAttribute('data-value');
        return { element: choice, index: index, key: sizeSortKey(value) };
      });
      if (entries.some(function (entry) { return !entry.key || entry.key.system !== entries[0].key.system; })) return;
      entries.sort(function (a, b) { return a.key.rank - b.key.rank || a.index - b.index; });
      if (entries.every(function (entry, index) { return entry.element === choices[index]; })) return;
      var selectedValue = select && select.value;
      entries.forEach(function (entry) { parent.appendChild(entry.element); });
      if (select) select.value = selectedValue;
    });
  }

  function initializeProduct(productSection) {
    if (!productSection) return;
    sortSizeOptions(productSection);
    if (productSection.hasAttribute(initializedAttribute)) return;

    var colorGroup = productSection.querySelector('[data-native-color-option][data-native-require-selection]');
    if (!colorGroup) return;

    productSection.setAttribute(initializedAttribute, 'true');

    var isModal = productSection.dataset.modal === 'true';
    var hasLinkedVariant = new URLSearchParams(window.location.search).has('variant');

    if (!isModal && !hasLinkedVariant) {
      var checkedColor = colorGroup.querySelector('input[type="radio"]:checked');
      var colorLabel = productSection.querySelector('[data-variant-color-label]');

      if (checkedColor) checkedColor.checked = false;
      productSection.querySelectorAll('.variant-input-wrap').forEach(function (group) {
        group.querySelectorAll('[data-variant-input]').forEach(function (input) {
          input.checked = false;
        });
        syncUnselectedOptionAvailability(productSection, group);
      });
      if (window.theme && theme.syncClearanceVariantOptions) {
        var variantsJson = productSection.querySelector('[data-variant-json]');
        if (variantsJson) theme.syncClearanceVariantOptions(productSection, JSON.parse(variantsJson.textContent || '[]'));
      }
      if (colorLabel) colorLabel.textContent = 'Choose a colour';
    }
    syncRequiredSelections(productSection);

    productSection.addEventListener('change', function (event) {
      var input = event.target;
      if (!input.matches('[data-variant-input]')) return;
      var group = input.closest('.variant-input-wrap');
      var optionName = group && (group.getAttribute('name') || group.dataset.handle || '');
      if (!/size|sizing/i.test(optionName) || colorGroup.querySelector('[data-variant-input]:checked')) return;

      var colors = colorGroup.querySelectorAll('input[type="radio"][data-variant-input]');
      if (colors.length !== 1 || colors[0].disabled) return;
      var color = colors[0];
      var variantsJson = productSection.querySelector('[data-variant-json]');
      if (!variantsJson) return;
      var variants;
      try {
        variants = JSON.parse(variantsJson.textContent || '[]');
      } catch (error) {
        return;
      }
      if (!variants.length || !variants.every(function (variant) {
        return variant[color.dataset.index] === color.value;
      })) return;

      color.checked = true;
      color.dispatchEvent(new Event('updateSwatch'));
      var selectedLabel = productSection.querySelector('[data-variant-color-label]');
      if (selectedLabel) selectedLabel.textContent = color.value;
      productSection.querySelectorAll('[data-awaiting-option]').forEach(function (element) {
        element.removeAttribute('data-awaiting-option');
      });
    }, true);

    colorGroup.addEventListener('change', function (event) {
      if (!event.target.matches('[data-variant-input]')) return;

      window.requestAnimationFrame(function () {
        productSection.querySelectorAll('[data-awaiting-option]').forEach(function (element) {
          element.removeAttribute('data-awaiting-option');
        });
        var selectedLabel = productSection.querySelector('[data-variant-color-label]');
        if (selectedLabel) selectedLabel.textContent = event.target.value;
        syncRequiredSelections(productSection);
      });
    });

    productSection.addEventListener('variantChange', function () {
      window.requestAnimationFrame(function () {
        syncRequiredSelections(productSection);
      });
    });
  }

  function initializeWithin(root) {
    if (!root) return;
    if (root.matches && root.matches('[data-section-type="product"]')) initializeProduct(root);
    root.querySelectorAll('[data-section-type="product"]').forEach(initializeProduct);
  }

  function initialize() {
    initializeWithin(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeWithin(event.target);
  });
})();
